export const STEPS = {
    INTRO: 'intro',
    SEARCH_RESULTS: 'searchResults',
    NO_SEARCH_RESULTS: 'noSearchResults',
    ARTICLE: 'article',
    ORDERS_LIST: 'ordersList',
    ORDER_INFO: 'orderInfo',
    CONTACT_SUPPORT: 'contactSupport',
    ERROR: 'error',
    CATEGORY: 'category',
    COMMON_QUESTIONS: 'commonQuestions',
    CMS_TOPIC: 'cmsTopic',
    CONTACT_SUPPORT_SEARCH: 'contactSupportSearch',
    ITEMS_LIST: 'itemsList',
    SELLER_ITEM: 'sellerItem',
    SELLER_ORDER: 'sellerOrder',
} as const;

export const ACTIONS = {
    SET_STEP: 'SET_STEP',
    OPEN_ARTICLE: 'OPEN_ARTICLE',
    GO_BACK: 'GO_BACK',
    SET_ORDER_ID: 'SET_ORDER_ID',
    SET_SEARCH_RESULTS_STEP: 'SET_SEARCH_RESULTS_STEP',
    SET_BUYER: 'SET_BUYER',
    SET_CATEGORY_ID: 'SET_CATEGORY_ID',
    SET_CMS_TOPIC_KEY: 'SET_CMS_TOPIC_KEY',
    SET_SHOW_FURTHER_SUPPORT: 'SET_SHOW_FURTHER_SUPPORT',
    SET_DISPLAY_FOOTER: 'SET_DISPLAY_FOOTER',
    SET_CONTACT_SUPPORT_SEARCH_QUERY: 'SET_CONTACT_SUPPORT_SEARCH_QUERY',
    SET_ITEM_ID: 'SET_ITEM_ID',
} as const;

export const RENDER_AS = {
    CONSUMER: 'consumer',
    LOGGED_OUT: 'loggedOut',
    SELLER: 'seller',
} as const;

export const GET_HELP_MODAL_ZENDESK_OPTIONS = 'GET_HELP_MODAL_ZENDESK_OPTIONS' as const;
